export class RepositoryError extends Error {
  constructor(message?: string, public readonly moreDetailedDescription?: string) {
    super(message)
  }
}
